export default "__VITE_ASSET__b879ef1c__"